export class Archivo {
    public idArchivo: number;
    public archivo: string;
    public archivoFisico: string;
    public tipo: string;
    public valor: string;
    public nombre: string;
    public idTipoArchivo: number;
    public idProceso: number;
    public idOrdenServicio: number;
    public ext: string;
    public comentario: string;
}

export class ArchivoSelected extends Archivo {
    public selected: boolean = false;
    public imgBlob: string = '';
}


// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/model/classes/archivo.ts